export const messageCreator = {
    user: 'user',
    agent: 'agent',
    llm: 'llm',
    faq: 'faq'
}

export const widgetKeys = {
    stockDetails: 'StockDetails',
    chart: 'Chart',
    news: 'News',
    portfolioDetails: 'PortfolioDetails',
}

export const finAgentUrlPrefix = 'finagent://'

export const finAgentMenuType = {
    stock: 'stock',
    portfolio: 'portfolio',
}

export const snippetTableType = {
    checkbox: 1,
    switch: 2
}

export const frequencyValues = {
    daily: 'daily',
    weekly: 'weekly',
    monthly: 'monthly',
    quarterly: 'quarterly',
    yearly: 'yearly',
    custom: 'custom',
};

export const repeatUnitValues = {
    day: "day",
    week: "week",
    month: "month",
    year: "year",
};

export const daysOfWeekValues = {
    sun: 0,
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6,
};

export const endsTypeValues = {
    never: "never",
    on: "onDate",
    after: "afterOccurrences",
};

export const snippetsSortTypes = {
    created: 'created',
    lastAccessed: 'lastAccessed',
    title: 'title',
};